import { createSlice } from "@reduxjs/toolkit";

export const stateDocument = createSlice({
  name: "stateDocument",
  initialState: {
    pageActive: JSON.parse(localStorage.getItem("pageActive")) || 1,
    folderActive: {
      folder_name: JSON.parse(localStorage.getItem("folderActiveDocument"))?.folder_name || null,
      folder_uuid: JSON.parse(localStorage.getItem("folderActiveDocument"))?.folder_uuid || null
    },
    files: [],
    systemUuid: JSON.parse(localStorage.getItem("systemUuid") || "{}") || null,
    menus: localStorage.getItem("menus") ? [...JSON.parse(localStorage.getItem("menus"))] : [],
    menuTreeDatas: JSON.parse(localStorage.getItem("menuTreeDatas") || "[]"),
    bodySearch: {
      folder_uuid: [
        {
          keyword: JSON.parse(localStorage.getItem("folderActiveDocument"))?.folder_uuid || null,
          condition: "EQ"
        }
      ]
    },
    isSearchKeyword: false,
    sorting: { key: "", direction: "" }
  },
  reducers: {
    setPageActive: (state, action) => {
      state.pageActive = action.payload;
      localStorage.setItem("pageActive", JSON.stringify(action.payload));
    },
    setFolderActive: (state, action) => {
      state.folderActive = action.payload;
      localStorage.setItem("folderActiveDocument", JSON.stringify(action.payload));
    },
    setFiles: (state, action) => {
      state.files = action.payload;
    },
    setMenus: (state, action) => {
      state.menus = action.payload;
      localStorage.setItem("menus", JSON.stringify(action.payload));
    },
    setBodySearch: (state, action) => {
      state.bodySearch = action.payload;
    },
    setMenuTreeDatas: (state, action) => {
      state.menuTreeDatas = action.payload;
      localStorage.setItem("menuTreeDatas", JSON.stringify(action.payload));
    },
    setSystemUuid: (state, action) => {
      state.systemUuid = action.payload;
      localStorage.setItem("systemUuid", JSON.stringify(action.payload));
    },
    setIsSearchKeyword: (state, action) => {
      state.isSearchKeyword = action.payload;
    },
    setSorting: (state, action) => {
      state.sorting = action.payload;
    }
  }
});

export const {
  setPageActive,
  setFolderActive,
  setFiles,
  setMenus,
  setBodySearch,
  setMenuTreeDatas,
  setSystemUuid,
  setIsSearchKeyword,
  setSorting
} = stateDocument.actions;

export default stateDocument.reducer;
